import React from 'react';

export default function EquipmentCatalog({ catalog }) {
  if (!catalog) return null;
  return <details className="equipment-catalog" open>
    <summary>{catalog.summary}</summary>
    <img src={catalog.src} alt={catalog.alt} loading="lazy" />
  </details>;
}
